import React, { useEffect } from 'react';
import { uuid } from '../CodesThatsGottaGoSomewhereElse';
import { LFC } from '../Legacy';
import { useResolve } from './Container';
import { ShortcutRegistry, ShortcutTarget } from './ShortcutRegistry';

export const Shortcut: LFC<{ name?: string, keys: string, target: ShortcutTarget }> = ({ name, keys, target, children }) => {
    const registry = useResolve(ShortcutRegistry);
    useEffect(() => registry.register(name ?? uuid(), keys, target), [name, keys, target]);
    return <>{children}</>;
};
